import {
  PivotTableGroup,
  PivotTableFields,
  Widget,
  DashboardWidgetName,
} from '@types'
import { TagClass } from '@/entities/tags'

import { TAG_FIELD } from '@/const'
import { WIDGETS_LIST } from '@/views/Dashboards/Dashboard/Widgets/utils/const'
import { ACCOUNT_TYPES_LIST } from '../Dashboard/Widgets/AccountsByType/utils/const'
import { CASH_FLOW_PROJECTIONS_DASHBOARD } from '../components/utils/const'

import { stringToDateTime } from '@/helpers/dates'
import { generateId } from '@/entities/utils/helpers'

import { getDefaultLinkedTransactionsAttrs, getDefaultTreePivotAttrs } from './widget-attrs'

export const prepareTagsList = (tagsBunch: Map<string, TagClass>, enabled = false) => {
  const result: PivotTableFields = {}
  const values = Array.from(tagsBunch.values())
  for (let i = 0; i < values.length; i++) {
    const tagName = values[i].field<string>(TAG_FIELD.TAG_NAME).value
    result[tagName] = {
      group: PivotTableGroup.ROWS,
      enabled,
    }
  }
  return result
}

export const getDatePoints = (dates: string[], date: string) => {
  const dateObject = stringToDateTime(date)
  const dateIndex = dates.findIndex(
    value => dateObject && stringToDateTime(value)?.hasSame(dateObject, 'day'),
  )
  let dateStart: string | undefined
  let dateEnd: string
  if (dates.length === 1) {
    dateStart = undefined
    dateEnd = dates[0]
  } else if (dateIndex === 0) {
    dateStart = undefined
    dateEnd = dates[0]
  } else {
    dateStart = dates[dateIndex - 1]
    dateEnd = date
  }
  return { dateStart, dateEnd }
}

export const prepareNewWidgetParams = (name: DashboardWidgetName) => {
  let attrs: Widget['attrs'] = {}
  let tall = undefined
  let wide = undefined
  let title =
    WIDGETS_LIST.find(item => item.name === name)?.label || 'New widget'
  switch (name) {
    case DashboardWidgetName.LinkedTransactions:
      title = 'Most recent linked transactions'
      attrs = getDefaultLinkedTransactionsAttrs()
      wide = true
      break
    case DashboardWidgetName.AccountsByType:
      attrs.type = ACCOUNT_TYPES_LIST[0]
      break
    case DashboardWidgetName.CashFlowProjections:
      attrs = CASH_FLOW_PROJECTIONS_DASHBOARD.widgets[0].attrs
      tall = true
      wide = true
      break
    case DashboardWidgetName.TreePivot:
      attrs = getDefaultTreePivotAttrs()
      tall = true
      wide = true
      break
  }
  return {
    id: generateId(),
    name,
    title,
    attrs,
    tall,
    wide,
  }
}
